<template>
  <div class="redEnvelopeActivity">
    <!-- 选择区 -->
    <div class="selectionArea">
      <el-button type="success" icon="el-icon-circle-plus" @click="dialogTableVisible = true">创建红包活动</el-button>

    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="act_name"
          label="活动名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="platform_name"
          label="所属平台"
          width="180"
          align="center"
        />
        <el-table-column
          prop="amount_type"
          label="红包金额"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.amount_type == 2">
              最小：{{ scope.row.amount_random[0] }}
              最大：{{ scope.row.amount_random[1] }}
            </div>
            <div v-if="scope.row.amount_type == 1">
              {{ scope.row.total_amount }}
            </div>

          </template>
        </el-table-column>
        <el-table-column
          prop="red_packet_no"
          label="红包活动编号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-warning defaultrse" />
            <i v-if="scope.row.status == 2" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 3" class="el-icon-close stopew" />
            <i v-if="scope.row.status == 4" class="el-icon-remove-outline stopew" />
            <i v-if="scope.row.status == 9" class="el-icon-delete-solid stopew" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="amount_type"
          label="金额类型"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ amount_types[scope.row.amount_type-1] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="wishing"
          label="祝福语"
          width="180"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="备注信息"
          width="180"
          align="center"
        />
        <el-table-column
          prop="total"
          label="发放总数"
          width="180"
          align="center"
        />
        <el-table-column
          prop="issued_total"
          label="已发出数量"
          width="180"
          align="center"
        />
        <el-table-column
          prop="get_total"
          label="领取数量"
          width="180"
          align="center"
        />
        <el-table-column
          prop="start_time_text"
          label="开始时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="end_time_text"
          label="结束时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="created_at_text"
          label="创建时间"
          width="180"
          align="center"
        />
        <el-table-column
          label="操作"
          min-width="180"
          align="center"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status_text === '待审核' || scope.row.status_text === '审核成功'"
              size="mini"
              type="primary"
              @click="updateState(scope.row)"
            >{{ scope.row.status_text === '待审核' ? '进行审核' : '活动暂停' }}</el-button>
            <el-button size="mini" style="margin-top:10px; margin-left:0px" type="warning" @click="bindPublicAccount(scope.row)">绑定公众号</el-button>
            <el-button size="mini" style="margin-top:10px; margin-left:0px" type="success" @click="bindaccount(scope.row.red_packet_no)">查看绑定的公众号列表
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />

    <el-dialog title="创建红包活动" :visible.sync="dialogTableVisible" :close-on-click-modal="false">
      <RedEnvelopes v-if="dialogTableVisible" @determine="submit" />
    </el-dialog>

    <el-dialog
      title="绑定公众号"
      :visible.sync="myBindpublicAccount"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <BindpublicAccount v-if="myBindpublicAccount" :red_packet_no="red_packet_no" @determine="binDetermine" />
    </el-dialog>
    <el-dialog
      title="查看绑定列表"
      :visible.sync="myBindlist"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <bindlist ref="messagedialogr" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败列表"
      :visible.sync="erroraccount"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" />
    </el-dialog>
  </div>
</template>

<script>
import { redPacketActivitylist, createRedPacket, redEnvelopeActivityBindingPublicAccount, redPacketActivityStatusUpdate } from '@/api/weChatMerchants.js'
import RedEnvelopes from './components/redEnvelopes.vue'
import BindpublicAccount from './components/bindpublicAccount.vue'
import bindlist from './components/bindlist.vue'
import errorlist from './components/errorlist.vue'
import paginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    RedEnvelopes,
    BindpublicAccount,
    paginationRight,
    bindlist,
    errorlist
  },
  data() {
    return {
      tableData: [],
      loading: false,
      parameter: {
        platform_id: null,
        page: 1,
        pageSize: 10
      },
      total: null,
      amount_types: ['固定金额', '随机金额'],
      dialogTableVisible: false,
      myBindpublicAccount: false,
      red_packet_no: null,
      myBindlist: false,
      erroraccount: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await redPacketActivitylist(this.parameter)
      this.total = data.data.total
      this.loading = false
      this.tableData = data.data.list
    },

    // 更新状态
    updateState(row) {
      console.log(row)
      if (row.status_text !== '审核成功' && row.status_text !== '待审核') {
        return
      }
      this.$confirm(row.status_text === '待审核' ? '是否推向审核' : '是否暂停活动', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await redPacketActivityStatusUpdate({ id: row.id, status: row.status_text === '待审核' ? 2 : 4 })
        this.$message({
          message: '修改状态成功',
          type: 'success'
        })
        this.getData()
      }).catch(() => {

      })
    },

    async submit(parameter) {
      console.log(parameter)
      if (this.parameterJudgment(parameter)) {
        return
      }
      await createRedPacket(parameter)
      this.dialogTableVisible = false
      this.getData()
      this.$message({
        message: '创建成功',
        type: 'success'
      })
    },

    // 参数判断
    parameterJudgment(parameter) {
      console.log('parameter', parameter)
      let text
      if (!parameter.platform_id) {
        text = '平台必须选'
      } else if (!parameter.act_name) {
        text = '活动名称必须填'
      } else if (!parameter.amount_type) {
        text = '金额类型必须选'
      // eslint-disable-next-line eqeqeq
      } else if (parameter.amount_type == 1 && !parameter.total_amount) {
        text = '固定红包金额必须填'
      // eslint-disable-next-line eqeqeq
      } else if (parameter.amount_type == 2 && parameter.amount_random[0] == null && parameter.amount_random[1] == null) {
        // eslint-disable-next-line eqeqeq
        text = '随机金额必须填'
        // console.log()
        // if (parameter.amount_random[0] == null || parameter.amount_random[1] == null) {
        //   text = '随机金额必须填'
        // } else if (parameter.amount_random[0] >= parameter.amount_random[1]) {
        //   text = '最小值不能大于最大值'
        // }
        // text = parameter.amount_random[0] >= parameter.amount_random[1] ? '最小值不能大于最大值' : '随机金额必须填'
      // eslint-disable-next-line eqeqeq
      } else if (parameter.amount_type == 2 && parameter.amount_random[0] >= parameter.amount_random[1]) {
        text = '最小值不能大于最大值'
      } else if (!parameter.wishing) {
        text = '祝福语必须填'
      } else if (!parameter.remark) {
        text = '备注信息必须填'
      } else if (!parameter.start_time) {
        text = '日期必须选'
      // eslint-disable-next-line eqeqeq
      } else if (parameter.start_time == parameter.end_time) {
        text = '结束时间不能等于开始时间'
      } else if (!parameter.total) {
        text = '发放总数必须填'
        console.log('parameter.start_time', parameter.start_time)
      } else if (parameter.tag_group_id == null) {
        text = '标签组id必须选'
      }

      if (text) {
        this.$message({
          message: text,
          type: 'warning'
        })
        return true
      }
    },

    // 绑定公众号
    bindPublicAccount(row) {
      this.red_packet_no = row.red_packet_no
      this.myBindpublicAccount = true
    },

    // 确定绑定公众号
    async binDetermine(parameter) {
      const data = await redEnvelopeActivityBindingPublicAccount({ ...parameter, app_ids: parameter.app_ids.map(item => item.id) })
      this.myBindpublicAccount = false
      console.log('data', data)
      // eslint-disable-next-line eqeqeq
      if (data.data.fail.length == 0) {
        this.$message({
          message: '绑定成功',
          type: 'success'
        })
      } else {
        this.erroraccount = true
        this.$nextTick(() => { // 请求成功之后，在这里执行
          this.$refs.errorlistview.send(data.data.fail)
        })
        // this.$message.error(`绑定失败的公众号${data.data.fail.join(',')}`)
      }
      this.getData()
    },

    fetchPageSizeone(e) {
      this.parameter.pageSize = e
      this.getData()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getData()
    },
    bindaccount(id) {
      this.myBindlist = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.messagedialogr.send(id)
      })
    }
  }
}
</script>

<style scoped>
.redEnvelopeActivity{
  width: 95%;
  margin: 0 auto;
  margin-top: 50px;
}
.selectionArea{
  margin-bottom: 20px;
  text-align: right;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
@media (max-width: 768px) {
  .item .text{
    font-size:3vw;
  }
}

</style>
